export default {
  conversas: [],
  mensagens: [],
  // has_more da CARGA INICIAL das mensagens (listarMensagens SEM before_id),
  // vindo do backend. Fonte de verdade para saber se o banco já veio esgotado
  // na 1ª carga — o chat-window lê isto para decidir, no 1º scroll ao topo,
  // se pagina o banco ou cai direto no import do WhatsApp. Default true
  // (assume que há mais até o backend dizer o contrário).
  mensagensHasMore: true,
  selectedConversa: null,
  loadingConversas: false,
  loadingMensagens: false,
  uploadProgress: null,
  replyTo: null,
  noteMode: false,
  editingMessage: null,
  respostasRapidas: [],
  filtroStatus: null,
  filtroProfissional: null,
  // Paginação incremental de conversas (scroll infinito)
  conversasPage: 1,
  conversasHasMore: true,
  loadingMoreConversas: false,
  // M1 — mapa { [message_id]: id_task } dos vínculos da conversa selecionada.
  linkedTaskByMessageId: {},
  // M1 — lista de tarefas (Gerenciador) vinculadas à conversa, com detalhes
  // (taskId, externalId, title, status, dueDate, priority) para a sidebar.
  linkedTaskList: [],
  // M2 — lista completa de notas internas da conversa selecionada.
  notasConversa: [],
  loadingNotas: false,
}
